import React, { useEffect, useState } from "react";
import "./Loader.css";
import brandLogo from "../../Images/newbrandlogo_nobg.png";

/* =========================================================================
   [GIF LOADER - KEEP FOR FUTURE USE]
   When you receive the new GIF, simply uncomment the import and the GIF render block below.
   ========================================================================= */
// import loaderMedia from "../../Videos/LapLoadergif.gif";
// const VIDEO_EXTENSIONS = ["mp4", "webm", "ogg", "mov"];
// function getExtension(src) {
//   const clean = src.split("?")[0];
//   return clean.split(".").pop().toLowerCase();
// }

export default function Loader({ isReady = false, minDisplayMs = 2000 }) {
  const [canHide, setCanHide] = useState(false);
  const [fading, setFading] = useState(false);
  const [hidden, setHidden] = useState(false);

  // Ensure loader stays visible for minDisplayMs (2000ms) to display animation smoothly
  useEffect(() => {
    const t = setTimeout(() => setCanHide(true), minDisplayMs);
    return () => clearTimeout(t);
  }, [minDisplayMs]);

  // Fade out once minDisplayMs passed — capped at 2000ms so loader never delays the app
  useEffect(() => {
    if (canHide && !fading) {
      setFading(true);
      const t = setTimeout(() => {
        setHidden(true);
        if (typeof window !== "undefined") {
          window.__lapstayLoaderDone = true;
          try {
            window.dispatchEvent(new CustomEvent("lapstay_loader_hidden"));
          } catch {}
        }
      }, 500);
      return () => clearTimeout(t);
    }
  }, [canHide, fading]);

  if (hidden) return null;

  return (
    <div
      className={`app-loader${fading ? " app-loader--fade" : ""}`}
      role="status"
      aria-live="polite"
    >
      <div className="lapstay-loader-wrap">
        {/* Ambient Radial Halo Aura */}
        <div className="lapstay-loader-halo" />

        {/* Radiant Energy Ripple Expanding Inside to Outside */}
        <div className="lapstay-loader-ripple" />

        {/* Animated Brand Logo: Emerges from inside towards outside */}
        <div className="lapstay-loader-logo-box">
          <img
            src={brandLogo}
            alt="LapStay Logo"
            className="lapstay-loader-logo-img"
          />
        </div>
      </div>

      {/* =================================================================
          [ORIGINAL GIF/VIDEO LOADER CODE - UNCOMMENT WHEN NEW GIF IS READY]
          =================================================================
      {isVideo ? (
        <video
          className="app-loader__video"
          src={loaderMedia}
          autoPlay
          loop
          muted
          playsInline
        />
      ) : (
        <img
          className="app-loader__video"
          src={loaderMedia}
          alt="Loading"
        />
      )}
      ================================================================= */}
    </div>
  );
}
